import '../styles/NewCrawlOpener.css';
import React from 'react';

function RuleMark() {
  return (
    <span className="nco-mark" aria-hidden="true">
      <svg viewBox="0 0 40 18" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 13.4 C7 10.6 12 15.2 18 12.1 C24 9 29 13.9 35 10.2 L38.6 8.2" />
        <path d="M33.4 4.6 L38.6 8.2 L34.6 12.4" />
        <circle cx="4.2" cy="6.6" r="1.3" fill="currentColor" stroke="none" />
      </svg>
    </span>
  );
}

function NewCrawlOpener() {
  return (
    <section className="nco-band" aria-labelledby="nco-title">
      <div className="nco-rail" data-content-rail="primary">
        <div className="nco-measure" data-content-rail="reading">
          <div className="nco-opener">
            <RuleMark />
            <p className="nco-label">New crawl</p>
          </div>
          <h1 id="nco-title" className="nco-title">Start a new crawl</h1>
          <p className="nco-lede">
            Give dbaseextractor one or more starting web page URLs or web directory locations. It
            fetches those pages in the background and extracts every email address it finds, keeping
            the results as durable lead records you can review on Leads.
          </p>
        </div>
      </div>
    </section>
  );
}

export default NewCrawlOpener;